import React from 'react';
import { FaChartLine, FaDownload, FaArrowUp, FaArrowDown, FaFilePdf, FaRocket, FaFilter, FaSearch } from 'react-icons/fa';
import { motion } from 'framer-motion';
import Header from '../Header';
import Footer from '../Footer';

const SEBIMonthlyRecommendations = () => {
  // Static stock recommendations data
  const stockRecommendations = [
    {
      id: 1,
      ticker: "TCS",
      name: "Tata Consultancy Services",
      recoPrice: "3,950.00",
      cmp: "4,125.50",
      returnPct: "+4.44%",
      stopLoss: "3,750.00",
      target: "4,500.00",
      rating: "BUY",
      status: "active",
      sector: "IT"
    },
    {
      id: 2,
      ticker: "RELIANCE",
      name: "Reliance Industries",
      recoPrice: "2,850.00",
      cmp: "2,920.25",
      returnPct: "+2.46%",
      stopLoss: "2,700.00",
      target: "3,200.00",
      rating: "HOLD",
      status: "active",
      sector: "Energy"
    },
    {
      id: 3,
      ticker: "HDFCBANK",
      name: "HDFC Bank",
      recoPrice: "1,650.00",
      cmp: "1,725.75",
      returnPct: "+4.59%",
      stopLoss: "1,580.00",
      target: "1,850.00",
      rating: "BUY",
      status: "active",
      sector: "Banking"
    },
    {
      id: 4,
      ticker: "INFY",
      name: "Infosys",
      recoPrice: "1,450.00",
      cmp: "1,380.50",
      returnPct: "-4.79%",
      stopLoss: "1,350.00",
      target: "1,600.00",
      rating: "BUY",
      status: "active",
      sector: "IT"
    },
    {
      id: 5,
      ticker: "ICICIBANK",
      name: "ICICI Bank",
      recoPrice: "1,120.00",
      cmp: "1,185.25",
      returnPct: "+5.83%",
      stopLoss: "1,050.00",
      target: "1,300.00",
      rating: "STRONG BUY",
      status: "active",
      sector: "Banking"
    },
    {
      id: 6,
      ticker: "SBIN",
      name: "State Bank of India",
      recoPrice: "680.00",
      cmp: "725.50",
      returnPct: "+6.69%",
      stopLoss: "640.00",
      target: "800.00",
      rating: "HOLD",
      status: "active",
      sector: "Banking"
    }
  ];

  // IPO Analysis Data
  const ipoAnalysis = [
    {
      id: 1,
      name: "Paytm Payments Bank",
      issuePrice: "₹2,150",
      cmp: "₹2,450",
      listingGain: "+13.95%",
      rating: "SUBSCRIBE",
      reportLink: "#",
      status: "Listed"
    },
    {
      id: 2,
      name: "LIC IPO",
      issuePrice: "₹949",
      cmp: "₹1,025",
      listingGain: "+8.01%",
      rating: "SUBSCRIBE",
      reportLink: "#",
      status: "Listed"
    },
    {
      id: 3,
      name: "Zomato",
      issuePrice: "₹76",
      cmp: "₹142",
      listingGain: "+86.84%",
      rating: "SUBSCRIBE",
      reportLink: "#",
      status: "Listed"
    },
    {
      id: 4,
      name: "Nykaa",
      issuePrice: "₹1,125",
      cmp: "₹2,150",
      listingGain: "+91.11%",
      rating: "SUBSCRIBE",
      reportLink: "#",
      status: "Listed"
    }
  ];

  return (
    <>
        <Header />
            <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden container mx-auto my-8">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-600 px-6 py-4">
                <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
                    <FaChartLine className="text-white text-lg" />
                    </div>
                    <div>
                    <h2 className="text-xl font-bold text-white">SEBI RA Monthly Recommendations</h2>
                    <p className="text-blue-100 text-sm">Live stock picks with detailed analysis</p>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <div className="bg-white/10 backdrop-blur-sm px-3 py-1 rounded-lg">
                    <span className="text-white text-sm">Updated: 15 Dec 2024</span>
                    </div>
                </div>
                </div>
            </div>

            {/* Content */}
            <div className="p-6">
                {/* Stats Overview */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl border border-green-200">
                    <div className="text-green-600 text-sm font-medium mb-1">Average Return</div>
                    <div className="text-2xl font-bold text-gray-900">+4.63%</div>
                    <div className="flex items-center text-green-600 text-sm mt-1">
                    <FaArrowUp className="mr-1" />
                    YTD Performance
                    </div>
                </div>
                
                <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-4 rounded-xl border border-blue-200">
                    <div className="text-blue-600 text-sm font-medium mb-1">Active Stocks</div>
                    <div className="text-2xl font-bold text-gray-900">24</div>
                    <div className="text-blue-600 text-sm mt-1">In Portfolio</div>
                </div>
                
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl border border-purple-200">
                    <div className="text-purple-600 text-sm font-medium mb-1">Success Rate</div>
                    <div className="text-2xl font-bold text-gray-900">85.7%</div>
                    <div className="text-purple-600 text-sm mt-1">Profitable Picks</div>
                </div>
                
                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 p-4 rounded-xl border border-yellow-200">
                    <div className="text-yellow-600 text-sm font-medium mb-1">Risk Level</div>
                    <div className="text-2xl font-bold text-gray-900">Medium</div>
                    <div className="text-yellow-600 text-sm mt-1">Balanced Approach</div>
                </div>
                </div>

                {/* Controls */}
                <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                <div className="flex items-center gap-3">
                    <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Search stocks..."
                        className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                    </div>
                    <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                    <FaFilter />
                    Filter
                    </button>
                </div>
                <div className="flex items-center gap-3">
                    <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                    <FaDownload />
                    Download Report
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50">
                    <FaRocket />
                    View All
                    </button>
                </div>
                </div>

                {/* Stock Recommendations Table */}
                <div className="overflow-x-auto rounded-xl border border-gray-200 mb-8">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ticker</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock Name</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reco Price</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">CMP</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Return %</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stop Loss</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rating</th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {stockRecommendations.map((stock) => (
                        <motion.tr
                        key={stock.id}
                        whileHover={{ backgroundColor: "rgba(59, 130, 246, 0.1)" }}
                        className="transition-colors"
                        >
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="font-bold text-gray-900">{stock.ticker}</div>
                        </td>
                        <td className="px-6 py-4">
                            <div className="text-sm font-medium text-gray-900">{stock.name}</div>
                            <div className="text-xs text-gray-500">{stock.sector}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">₹{stock.recoPrice}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-bold text-gray-900">₹{stock.cmp}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            stock.returnPct.startsWith('+') 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                            {stock.returnPct.startsWith('+') ? <FaArrowUp className="mr-1" /> : <FaArrowDown className="mr-1" />}
                            {stock.returnPct}
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-red-600 font-medium">₹{stock.stopLoss}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-green-600 font-medium">₹{stock.target}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className={`px-3 py-1 rounded-full text-xs font-bold text-center ${
                            stock.rating === 'BUY' ? 'bg-green-100 text-green-800' :
                            stock.rating === 'STRONG BUY' ? 'bg-emerald-100 text-emerald-800' :
                            stock.rating === 'HOLD' ? 'bg-yellow-100 text-yellow-800' :
                            'bg-red-100 text-red-800'
                            }`}>
                            {stock.rating}
                            </div>
                        </td>
                        </motion.tr>
                    ))}
                    </tbody>
                </table>
                </div>

                {/* IPO Analysis Section */}
                <div className="bg-gradient-to-r from-gray-50 to-blue-50/30 rounded-xl p-6 border border-gray-200">
                <div className="flex items-center justify-between mb-6">
                    <div>
                    <h3 className="text-lg font-bold text-gray-900">Latest IPO Listings & Analysis</h3>
                    <p className="text-gray-600 text-sm">Detailed ratings and booklet download links</p>
                    </div>
                    <div className="flex items-center gap-2">
                    <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                        IPO Season Active
                    </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {ipoAnalysis.map((ipo) => (
                    <motion.div
                        key={ipo.id}
                        whileHover={{ y: -5 }}
                        className="bg-white rounded-xl p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                    >
                        <div className="flex justify-between items-start mb-3">
                        <div>
                            <h4 className="font-bold text-gray-900">{ipo.name}</h4>
                            <p className="text-gray-500 text-sm">Issue: {ipo.issuePrice}</p>
                        </div>
                        <div className={`px-2 py-1 rounded text-xs font-bold ${
                            ipo.rating === 'SUBSCRIBE' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                            {ipo.rating}
                        </div>
                        </div>
                        
                        <div className="space-y-2 mb-4">
                        <div className="flex justify-between">
                            <span className="text-gray-600 text-sm">CMP:</span>
                            <span className="font-bold text-gray-900">{ipo.cmp}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600 text-sm">Listing Gain:</span>
                            <span className="font-bold text-green-600">{ipo.listingGain}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600 text-sm">Status:</span>
                            <span className="font-medium text-blue-600">{ipo.status}</span>
                        </div>
                        </div>
                        
                        <button className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                        <FaFilePdf />
                        Download Analysis
                        </button>
                    </motion.div>
                    ))}
                </div>
                </div>

                {/* Footer Note */}
                <div className="mt-8 p-4 bg-yellow-50 border-l-4 border-yellow-500 rounded">
                <p className="text-yellow-800 text-sm">
                    <span className="font-bold">Note:</span> All recommendations are based on SEBI registered research. 
                    Past performance is not indicative of future returns. Investors should consult with their financial 
                    advisors before making any investment decisions.
                </p>
                </div>
            </div>
            </div>
        <Footer />
    </>
  );
};

export default SEBIMonthlyRecommendations;